import React, { useEffect, useState } from 'react'
import img from '../../../assets/users/helene-engels.png'
import bookmaker from '../../../assets/icons/bookmaker-svgrepo-com.svg'
import { BiPlus } from 'react-icons/bi'
import { CgClose } from 'react-icons/cg'
import Expérience from './partials/Expérience'
import PersonnalInfo from './partials/PersonnalInfo'
import Skills from './partials/Skills'
import Qualities from './partials/Qualities'
import Education from './partials/Education'
import Language from './partials/Language'
import Bio from './partials/Bio'
import { GoDownload } from 'react-icons/go'
import ResumeUI, { PrintResume2 } from '../../../../ui/Resume'
import { useSelector } from 'react-redux'
import { RESUME_API_END_POINT, USER_API_END_POINT } from '../../../../utils/constant'
import axios from 'axios'
import PrintResume from "../../../../ui/Resume"

const Resume = () => {
  const {user} = useSelector(store=>store.user)
  const [data, setData] = useState({})
  const [resumeDetail, setResumeDetail] = useState({})

  useEffect(() => {
    fetchCandidateDetails();
  }, []);
  
  // Fetch skills from API
  const fetchCandidateDetails = () => {
    axios.get(`${RESUME_API_END_POINT}/detail/${user.id}`)
      .then((response) => {
        setData(response.data);
        setResumeDetail(response.data);
      })
      .catch((error) => {
        console.error("Error fetching details:", error);
      });
  };
  
  // Surveille la mise à jour de resumeDetail
  useEffect(() => {
    console.log("Données utilisateur mises à jour:", resumeDetail);
  }, [resumeDetail]);

  return (
    <div className=' min-h-full w-full pr-6 lg:pr-6 xl:pr-40 pl-6 text-primary-black py-6 ' >
     <div className="flex justify-between items-center mb-6">
        <h1 className='font-semibold'>Mon CV</h1>
     </div>
        <div className="grid grid-cols-1  gap-4 text-sm">
            <div className="col-span-4 ">
            <div className="flex justify-between items-center mb-4 border p-4 rounded-md">
                <div className="flex gap-4">
                <img src={img} alt="image" className='w-14 h-14 rounded-full'/>
                    <div className="flex-col flex justify-between text-start">
                        <h4 className='text-xl font-semibold'>{user?.candidate_profile?.name}</h4>
                        <p className='text-primary-text'>{user?.candidate_profile?.current_job}</p>
                    </div>
                </div>
                <div className="flex gap-x-2">
                {/* <button className="px-6 py-2 border rounded-md flex gap-1 items-center text-black"><GoDownload/> Mon CV</button> */}
                <PrintResume2 data={resumeDetail} />
                </div>
            </div>
            {/* <PrintResume2 data={resumeDetail} /> */}
            
            <div className="space-y-6">
                {/* Bio */}
                <Bio data={resumeDetail} setData={setData}/>

                {/* Information personnel */}
                <PersonnalInfo data={resumeDetail} setData={setData}/>

                {/* Compétence */}
                <Skills data={resumeDetail} setData={setData}/>

                {/* Qualité */}
                <Qualities data={resumeDetail} setData={setData}/>

                {/* Expérience */}
                <Expérience data={resumeDetail} setData={setData}/>

                {/* Education */}
                <Education data={resumeDetail} setData={setData}/>

                {/* Langues */}
                <Language data={resumeDetail} setData={setData}/>
            </div>
            </div>

                

            </div>
            {/* <ResumeUI/> */}
        </div>
  )
}

export default Resume